import React from 'react';
import type { Question, Language } from '@nordcrest/shared';

interface CheckboxProps {
  question: Question;
  value: boolean;
  onChange: (value: boolean) => void;
  language: Language;
  error?: string;
}

export function Checkbox({ question, value, onChange, language, error }: CheckboxProps) {
  return (
    <div>
      <label className="flex items-start cursor-pointer group">
        <div className="relative flex items-center justify-center mt-0.5">
          <input
            type="checkbox"
            checked={value}
            onChange={(e) => onChange(e.target.checked)}
            className="sr-only"
          />
          <div
            className={`w-5 h-5 border-2 rounded flex items-center justify-center transition-colors ${
              value
                ? 'bg-primary-500 border-primary-500'
                : 'border-gray-300 group-hover:border-primary-400'
            }`}
          >
            {value && (
              <svg
                className="w-3 h-3 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={3}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            )}
          </div>
        </div>
        <div className="ml-3">
          <span className="text-gray-900">{question.text[language]}</span>
          {question.description && (
            <p className="text-sm text-gray-500 mt-1">
              <a
                href="#"
                className="text-primary-600 hover:underline"
                onClick={(e) => e.stopPropagation()}
              >
                {question.description[language]}
              </a>
            </p>
          )}
        </div>
      </label>
      {error && <p className="text-sm text-red-600 mt-2 ml-8">{error}</p>}
    </div>
  );
}
